"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AllMeetingsPageActions;
(function (AllMeetingsPageActions) {
    AllMeetingsPageActions["MeetingsLoaded"] = "MeetingsLoaded";
    AllMeetingsPageActions["MeetingDetailButtonClicked"] = "MeetingDetailButtonClicked";
    AllMeetingsPageActions["MeetingDetailClosed"] = "MeetingDetailClosed";
    AllMeetingsPageActions["MeetingDetailFormOpened"] = "MeetingDetailFormOpened";
})(AllMeetingsPageActions || (AllMeetingsPageActions = {}));
exports.default = AllMeetingsPageActions;
